import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';

export interface TableState<TableFilters = unknown> {
  pageIndex: number;
  pageSize: number;
  sortActive: string;
  sortDirection: SortDirection;
  filters: TableFilters;
  filtersExpanded: boolean;
  allColumnKeys: string[],
  selectedColumnKeys: string[];
}

@Injectable({
  providedIn: 'root'
})
export class TableStateService {
  private readonly key = 'tableStates';

  setState<TFilters>(tableId: string, state: TableState<TFilters>) {
    const allStates = this.getAllStates();
    allStates[tableId] = state;
    localStorage.setItem(this.key, JSON.stringify(allStates));
  }

  getState<TFilters>(tableId: string): TableState<TFilters> | null {
    const allStates = this.getAllStates();
    const state = allStates[tableId];
    return state ? (state as TableState<TFilters>) : null;
  }

  clearState(tableId: string) {
    const allStates = this.getAllStates();
    delete allStates[tableId];
    localStorage.setItem(this.key, JSON.stringify(allStates));
  }

  private getAllStates(): Record<string, TableState> {
    const raw = localStorage.getItem(this.key);
    return raw ? JSON.parse(raw) : {};
  }
}
